import { useMemo } from 'react';
import { NextPage } from 'next';

import { PageSection } from 'types/pages';
import { Routes } from 'types/routes';

import { withVariables } from 'utils/string';

import Head from 'components/layout/Head';
import PageContainer from 'components/layout/PageContainer';
import SectionsWrapper from 'components/layout/SectionsWrapper';
import WrapperPublic from 'components/wrappers/Public';

import SectionCourses from './sections/Courses';
import SectionCta from './sections/Cta';
import SectionHero from './sections/Hero';
import StyledComponent from './styles';
import { Props } from './types';

const PageCourses: NextPage<Props> = ({ pageTranslations, courseCategories, courses, initialLeadId }) => {
    const sections: PageSection[] = useMemo(() => [{
        slug: 'hero',
        order: 1,
        isVisible: true,
        children: (slug, translations) => (
            <SectionHero
                key={slug}
                translations={translations}
            />
        ),
    }, {
        slug: 'courses',
        order: 2,
        isVisible: true,
        children: (slug, translations) => (
            <SectionCourses
                key={slug}
                translations={translations}
                courses={courses}
                courseCategories={courseCategories}
                initialLeadId={initialLeadId}
            />
        ),
    }, {
        slug: 'cta',
        order: 3,
        isVisible: true,
        children: (slug, translations) => (
            <SectionCta
                key={slug}
                translations={translations}
            />
        ),
    }], []);

    return (
        <WrapperPublic>
            <StyledComponent className="page-courses">
                <Head
                    title={pageTranslations?.page?.metaTitle}
                    description={pageTranslations?.page?.metaDescription}
                    canonical={withVariables(Routes.PublicCourses)}
                />
                <PageContainer>
                    <SectionsWrapper
                        sections={sections}
                        localTranslations={pageTranslations?.sections}
                        enabledStates={pageTranslations?.sectionsEnabled}
                    />
                </PageContainer>
            </StyledComponent>
        </WrapperPublic>
    );
};

export default PageCourses;
